<template>
  <div class="result-box" :class="borderClass">
    <div class="me-2">
      <!-- Se l'animazione è in corso, mostra sempre l'icona gialla -->
      <i v-if="isAnimating" class="la la-exclamation-triangle" style="color: yellow; font-size: 24px;"> </i>

      <!-- Altrimenti, determina l'icona in base al colore -->
      <i v-else-if="borderClass === 'border-green'" class="mdi mdi-check-circle-outline" style="color: green; font-size: 24px;"> </i>
      <i v-else-if="borderClass === 'border-yellow'" class="la la-exclamation-triangle" style="color: yellow; font-size: 24px;"> </i>
      <i v-else class="mdi mdi-close-circle-outline" style="color: red; font-size: 24px;"> </i>
    </div>
    <p>{{ title }}</p>
    <p class="country-box">
      &#x2022; 
      <span v-if="getFlag(data)?.icon">
        <i :class="getFlag(data).icon"></i> {{ getFlag(data).text }}
      </span>
      <span v-else>
        {{ data ? $t(data?.toLowerCase()) : '' }}
        <img :src="data ? getFlag(data?.toLowerCase()) : ''" class="flag-image" />
      </span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    data: {
      type: [String, Object],
      required: false,
      default: null
    },
    borderClass: {
      type: String,
      required: true
    },
    isAnimating: {
      type: Boolean,
      default: false
    },
    getFlag: {
      type: Function,
      required: true
    }
  }
};
</script>
  
<style scoped>
p {
  margin: 0; /* Remove margin */
}

.result-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #0d1b2a;
  padding: 10px;
  margin: 5px 0;
  border-radius: 5px;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 768px) {
  .result-box {
    width: 90%; /* Width for mobile */
  }
}

.border-green {
  border: 1px solid #00ff00;
}

.border-yellow {
  border: 1px solid #ffff00;
}

.border-red {
  border: 1px solid #ff0707;
}


.country-box {
  text-align: right;
  flex: 1;
}

.country-box img.flag-image {
  height: 1em;
  margin-left: 15px;
}

</style>
  